// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261108/js/" + chunkId + "." + {"44":"3fa1ee8e","225":"0a5220c5","481":"a0c92fd5","486":"931e3ff0","770":"e492f117"}[chunkId] + ".0.737868546259662.chunk.js";
};